import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';

import { ProtocolImportCandidate } from '@lib/protocols/data-access';
import { TranslatePipe } from '@ngx-translate/core';

import { ProtocolCodeViewComponent } from '../protocol-code-view/protocol-code-view.component';

@Component({
  selector: 'protocols-import-candidate-card',
  standalone: true,
  imports: [ProtocolCodeViewComponent, TranslatePipe],
  templateUrl: './protocol-import-candidate-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProtocolImportCandidateCardComponent {
  readonly candidate = input.required<ProtocolImportCandidate>();
  readonly confirmed = input<boolean>(false);
  readonly confirmedChange = output<boolean>();

  protected readonly expanded = signal(false);

  protected readonly unresolvedCodes = computed(() => this.candidate().validation.codes.filter(code => !code.found));

  protected readonly validationErrors = computed(() => this.candidate().validation.errors);

  protected readonly parseErrors = computed(() => this.candidate().parseErrors);

  protected readonly hasDetails = computed(() => this.validationErrors().length > 0 || this.parseErrors().length > 0);

  protected toggle(event: Event): void {
    this.confirmedChange.emit((event.target as HTMLInputElement).checked);
  }

  protected toggleExpanded(): void {
    this.expanded.set(!this.expanded());
  }
}
